import { doLinesIntersect as n } from "./core/index20.js";
const s = (r, o) => {
  for (let e = 0; e < r.length - 1; e++)
    for (let t = 0; t < o.length - 1; t++)
      if (n(
        [r[e], r[e + 1]],
        [o[t], o[t + 1]]
      ))
        return !0;
  return !1;
};
export {
  s as doPolysIntersect
};
//# sourceMappingURL=index6.js.map
